<template>
  <div class="event-start-page">
    <div class="top-line">
      <div class="backblock">
        <SvgIcon class="forward-icon" name="forward" width="18px" height="18px"></SvgIcon>Назад
      </div>
      <SvgIcon name="dots" width="15px" height="15px"></SvgIcon>
    </div>

    <div class="news-zone">
      <section class="picture-zone-message">
        <div class="img-news" :style="bg()"></div>
      </section>
      <section class="event-info">
        <h5 ref="postTitle">{{typo(post.title||'Название поста')}}</h5>
        <div ref="postDescr" class="description">{{typo(post.text||'Тект поста')}}</div>
      </section>
      <section class="promocode-wrap">
        <div class="promocode">
          Промокод:
          <div class="code">{{post.promocode||'ONLYLOVE'}}</div>
        </div>
      </section>
      <section class="btn-wrap">
        <button class="btn btn-primary">{{post.button||'Позвонить'}}</button>
      </section>
    </div>
  </div>
</template>

<script>
import Typograf from "typograf";
let tp = new Typograf({ locale: ["ru", "en-US"] });
export default {
  name: "EventPost",
  props: ["post", "event", "profile"],
  methods: {
    typo: function(text) {
      return tp.execute(text);
    },
    bg: function() {
      if (this.post.files.length) {
        return `background-image:url(${this.post.files[0].url})`;
      }
    }
  },
  watch: {
    "post.title": function() {
      if (this.$refs.postTitle.offsetHeight > 74)
        this.$refs.postTitle.classList.add("overflowed");
      else this.$refs.postTitle.classList.remove("overflowed");
    },
    "post.text": function() {
      if (this.$refs.postDescr.offsetHeight > 110)
        this.$refs.postDescr.classList.add("overflowed");
      else this.$refs.postDescr.classList.remove("overflowed");
    }
  },
  mounted() {
    this.$parent.mActive = "news";
  }
};
</script>

<style lang="scss" scope>
.event-start-page {
  height: 100%;
  background: #fff;
}
.top-line {
  display: flex;
  align-items: center;
  padding: 10px;
  justify-content: space-between;
  background: #fff;
  .backblock {
    color: $mainColor;

    font-size: 14px;
    line-height: 1.25;
    letter-spacing: -0.41px;
  }

  .forward-icon {
    transform: rotate(180deg);
  }
  .select {
    color: $mainColor;
    font-size: 13px;
    line-height: 2.3;
  }
}
.news-zone {
  background-color: #fff;
  overflow: hidden;
  .picture-zone-message {
    .img-news {
      background-image: url("~@/assets/fotty.jpg");
      width: 100%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      height: 150px;
    }
  }
  .event-info {
    padding: 15px;
    font-size: 12px;
    line-height: 20px;
    h5 {
      font-weight: bold;
      font-size: 13px;
      line-height: 21px;
      text-overflow: ellipsis;
      overflow: hidden;
      max-height: 75px;

      &.overflowed {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          width: 100%;
          height: 16px;
          bottom: 0;
          left: 0;
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0) 0%,
            #ffffff 83.98%
          );
        }
      }
    }
    .description {
      max-height: 113px;
      text-overflow: ellipsis;
      overflow: hidden;
      &.overflowed {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          width: 100%;
          height: 16px;
          bottom: 0;
          left: 0;
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0) 0%,
            #ffffff 83.98%
          );
        }
      }
    }
  }
  .promocode-wrap {
    padding: 7px 15px;
    font-size: 13px;
    line-height: 21px;

    display: flex;
    justify-content: space-between;
    color: $calmColor;

    .promocode {
      display: flex;
      justify-content: center;
      color: #333;
      flex: 1 0 auto;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.08);
      padding: 8px 0;

      .code {
        margin-left: 5px;
        color: $mainColor;
      }
    }
  }
  .btn-wrap {
    padding: 7px 15px;
    .btn {
      width: 100%;
      padding: 8px;
      font-weight: 600;
      font-size: 13px;
    }
  }
}
</style>
